import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Config } from "../../core/config/config";
import { Grid } from "../../core/components/grid";
import { DialogHelper } from "../../core/util/dialogHelper";
import { General } from "../../../siteManagement/general";
import { SheetEventType } from "../../../siteManagement/sheet";
import { AppHelper } from "../../appHelper";
import { AppBaseProps, CommonApp, Entity } from "../../core/components/commonApp";
import { Helper } from "../../core/util/helper";
import { NotificationHelper } from "../../core/util/notificationHelper";
import EditTranslationsInGrid, { UebersetungInGrid } from "../editTranslationsInGrid";
import { ContextGeneralSettingsApp } from "../generalSettings";
import { BaseField } from "../../core/components/baseComponentProps";
import React from "react";
export default class TicketInternalStatusGrid extends React.Component<TicketInternalStatusGridProps, { gridData: TicketInternalStatus[] }> {
    private metaData: any;
    constructor(props) {
        super(props);
        this.state = { gridData: [] };
        this.initApp();
    }

    private initApp = () => {
        this.metaData = {
            additional: {
                objects: []
            },
            tabs: [
                {
                    iconName: "square-exclamation",
                    title: Helper.getTranslation("Server.Allgemein"),
                    regions: [
                        {
                            title: Helper.getTranslation("Server.Allgemein"),
                            visible: true,
                            fields: [
                                {
                                    model: "entity.Code",
                                    name: Helper.getTranslation("Standard.Key"),
                                    readOnly: true,
                                    visible: true,
                                    type: "is-numeric-text-box",
                                    format: "0",
                                    decimals: 0,
                                    required: true
                                }
                            ]
                        },
                        {
                            title: Helper.getTranslation("BrowserTitle.Translations"),
                            visible: true,
                            fields: [
                                {
                                    labelAndControlCombined: true,
                                    maxLenght: 60,
                                    model: "entity.Translations",
                                    componentName: "renderEditTranslationsInGrid()",
                                    name: "Translations",
                                    readOnly: false,
                                    type: "dynamic",
                                    visible: true
                                }

                            ]
                        }

                    ]
                }
            ],
            menuDataSource: [
                {
                    type: "save"
                },
                {
                    type: "delete",
                    onClick: "deleteStatus()",
                    show: "!entity.IsNew"
                }
            ]
        };
        this.loadGridData();
    }

    private loadGridData = async () => {
        const result = await HTTPService.get<JsonResultClass<TicketInternalStatus[]>>("GeneralSettings/GetTicketInternalStatus");
        this.setState({ gridData: result.Data })
    }

    private handleClickStandardButton = async (type: ToolBarStandardButtonType, dataItem: TicketInternalStatus) => {
        switch (type) {
            case ToolBarStandardButtonType.EDIT:
                this.openSheet(dataItem);
                break;
        }
    }

    private openSheet = (dataItem: TicketInternalStatus) => {
        const props: EditTicketInternalStatusProps = {
            context: {
            },
            dataSources: {},
            entity: Object.assign(dataItem, { RecordRight: this.props.entity.RecordRight }),
            isWindow: false,
            metadata: this.metaData,
            title: ""
        }
        const sheet = General.Sheet.Manager.createSheet();
        sheet.bind(SheetEventType.Close, this.loadGridData);
        sheet.setTitle(Helper.getTranslation("Field.Vorgang.ticketStateIntern"));
        sheet.show(() => {
            sheet.mountContent(EditTicketInternalStatus, props);
        });

    }

    render() {

        const standardButtons: Array<ToolBarStandardButton> = [
            { type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: !this.props.disabled }
        ];


        return (
            <div style={{ height: "100%", width: "100%" }}>
                <div className="flex-container flex-container__item" style={this.props.field.style}>
                    <Grid data={this.state.gridData} options={this.props.context.editTicketInternalStatusGridOptions} id="editTicketInternalStatusGrid"
                        standardButtons={standardButtons} onClickStandardButton={this.handleClickStandardButton} />
                </div>
            </div>
        );
    }
};

interface TicketInternalStatusGridProps {
    field: EditTicketInternalStatusField;
    context: ContextGeneralSettingsApp;
    disabled: boolean;
    entity: any;
}

interface TicketInternalStatus extends Entity {
    Code: string;
    Status: string;
    IsRowId: number;
    Translations: UebersetungInGrid[]
}

interface EditTicketInternalStatusField extends BaseField {
    style: React.CSSProperties
}

class EditTicketInternalStatus extends React.Component<EditTicketInternalStatusProps, any>{
    private editTranslationsInGridRef: EditTranslationsInGrid;

    common = new AppHelper();
    constructor(props) {
        super(props)
        this.common.enableHooks = false;
        this.common.init(this);
    }

    handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    save = async () => {
        const result = await HTTPService.post<JsonResultClass>("GeneralSettings/SaveTicketInternalStatus", {
            vm: this.props.entity
        });
        if (result.Code == 0) {
            NotificationHelper.showSuccessMessage(Helper.getTranslation("Standard.Msg.SpeichernErfolgreich"));
            this.editTranslationsInGridRef.markAsSaved();
        } else {
            NotificationHelper.showErrorMessage(result.Message)
        }
        this.common.handlePostSave(result.Code === 0, false);
        this.setState({});
    }

    renderEditTranslationsInGrid = () => {
        let translationColumns = [
            {
                visible: true,
                width: "100",
                field: "Value0",
                title: Helper.getTranslation("Field.Ressource.name")
            }
        ];

        return <EditTranslationsInGrid
            id={"editTicketInternalStatusTranslationsInGrid"}
            gridData={this.props.entity.Translations}
            translationColumns={translationColumns}
            ref={(ref) => this.editTranslationsInGridRef = ref} />
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { apphelper: this.common, handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}

interface EditTicketInternalStatusProps extends AppBaseProps {
    entity: TicketInternalStatus;
}
